const formatDateForDisplay = (date) => {
  return {
    full: date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
      day: "numeric"
    }),
    dayOfWeekLong: date.toLocaleString("en-US", {
      weekday: "long"
    }),
    dayOfWeek: date.toLocaleString("en-US", {
      weekday: "short"
    }),
    month: date.toLocaleString("en-US", {
      month: "short"
    }),
    day: date.toLocaleString("en-US", {
      day: "numeric"
    }),
    time: date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric"
    }).replace(" AM", "am").replace(" PM", "pm")
  };
};
export {
  formatDateForDisplay
};
//# sourceMappingURL=formatDateForDisplay.js.map
